declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    facebook: {
      /**
       * Add an image
       */

      insertFacebook: (url?: string, className?: string) => ReturnType
    }
  }
}

import { Node, mergeAttributes } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import FacebookEmbed from './FacebookEmbed.js'

export const Facebook = Node.create({
  name: 'facebook',
  group: 'block',
  content: 'inline*',
  draggable: true,

  // content: 'inline*',
  parseHTML() {
    return [
      {
        tag: 'div[data-type="facebook-post"]',
      },
    ]
  },

  addAttributes() {
    return {
      url: { default: null },
      class: { default: null },
      src: {
        default: null,
      },
      width: {
        default: '100%',
      },

      showText: {
        default: true,
      },
    }
  },
  addKeyboardShortcuts() {
    return {
      'Mod-Enter': () => {
        return this.editor
          .chain()
          .insertContentAt(this.editor.state.selection.head, {
            type: this.type.name,
          })
          .focus()
          .run()
      },
    }
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-type": "facebook",
        class: `react-renderer node-facebook ${HTMLAttributes.class ?? ""}`,
      }), [
        'div',
        mergeAttributes(
          { class: 'socialMediaContainer' },
        ),
        ['div', { class: 'rsme-embed rsme-facebook-embed', },
          [
            'div',
            { class: 'rsme-d-none' },
            ['div', { id: 'fb-root' }],
            [
              'div',
              mergeAttributes(HTMLAttributes, {
                class: 'fb-post',
                'data-href': HTMLAttributes.url,
                'data-width': '500',
                'data-show-text': "true",
              })
            ],
            [
              'script',
              {
                async: true,
                defer: true,
                crossorigin: 'anonymous',
                src: 'https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v22.0',

              },
            ],
          ]
        ]

      ]]
  },


  addNodeView() {
    return ReactNodeViewRenderer(FacebookEmbed)
  },

  addCommands() {
    return {
      insertFacebook:
        (url, className) =>
          ({ commands, state }) => {
            return commands.insertContent({
              type: 'facebook',
              attrs: {
                url,
                class: className,
                src: url,
              },
            })
          },
    }
  },
})

function isValidHttpUrl(string: string) {
  let url

  try {
    url = new URL(string)
  } catch (_) {
    return false
  }

  return url.protocol === 'http:' || url.protocol === 'https:'
}
